<template>
  <div v-if="title.length > 0" class="drag-title-block">
    <div class="drag-title-block__dots">
      <div class="drag-title-block__dot"></div>
      <div class="drag-title-block__dot"></div>
      <div class="drag-title-block__dot"></div>
    </div>

    <div class="drag-title-block__title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'DragTitleBlock',

  props: {
    title: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.drag-title-block {
  display: flex;
  align-items: space-between;
  align-items: center;
  padding: 10px 10px 10px 20px;
  background: $background;
  cursor: grab;
  transition: background ease-in-out 0.4s;

  &:hover {
    background: $white;
    transition: background ease-in-out 0.4s;
  }

  &__dots {
    text-align: center;
    display: block;
    margin-right: 10px;
  }

  &__dot {
    width: 4px;
    height: 4px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 3px 2px;
    display: block;
  }

  &__title {
    @include mixin-text-header-big;
    flex: 1;
  }
}
</style>
